import { i18n } from "us.helper";
export enum DocumentManagerColumKeys {
  DOCUMENT_NAME = "documentName",
  ASSIGNED_TO = "assignTo",
  MAPPED_BY = "mappedBy",
  DATE = "mappedDate",
  CATEGORY = "documentCategory",
  TYPE = "entityType",
  ACTIONS = "actions",
}

export const DocumentsManagerHistoryColumns: any = [
  {
    title: "US.COLLECTION.INPUT-OUTPUT:DOCUMENTS_MANAGER_HISTORY.DOCUMENT_NAME",

    dataIndex: DocumentManagerColumKeys.DOCUMENT_NAME,
    key: DocumentManagerColumKeys.DOCUMENT_NAME,
    width: 150,
    ellipsis: true,
  },
  {
    title: "US.COLLECTION.INPUT-OUTPUT:DOCUMENTS_MANAGER_HISTORY.ENTITY_TYPE",

    dataIndex: DocumentManagerColumKeys.TYPE,
    key: DocumentManagerColumKeys.TYPE,
    width: 80,
    ellipsis: true,
    customSorter: (a: any, b: any) => a - b,
    customFilter: true,
  },
  {
    title: "US.COLLECTION.INPUT-OUTPUT:DOCUMENTS_MANAGER_HISTORY.ASSIGNED_TO",

    dataIndex: DocumentManagerColumKeys.ASSIGNED_TO,
    key: DocumentManagerColumKeys.ASSIGNED_TO,
    width: 130,
    ellipsis: true,
    customSorter: (a: any, b: any) => a - b,
    customFilter: true,
  },
  {
    title: "US.COLLECTION.COMMON:COMMON.CATEGORY",
    dataIndex: DocumentManagerColumKeys.CATEGORY,
    key: DocumentManagerColumKeys.CATEGORY,
    width: 130,
    ellipsis: true,
    customSorter: (a: any, b: any) => a - b,
  },
  {
    title: "US.COLLECTION.INPUT-OUTPUT:DOCUMENTS_MANAGER_HISTORY.ASSIGNED_BY",

    dataIndex: DocumentManagerColumKeys.MAPPED_BY,
    key: DocumentManagerColumKeys.MAPPED_BY,
    width: 130,
    ellipsis: true,
    customSorter: (a: any, b: any) => a - b,
    customFilter: true,
  },
  {
    title: "US.COLLECTION.INPUT-OUTPUT:DOCUMENTS_MANAGER_HISTORY.ASSIGNED_DATE",

    dataIndex: DocumentManagerColumKeys.DATE,
    key: DocumentManagerColumKeys.DATE,
    width: 130,
    ellipsis: true,
    customSorter: (a: any, b: any) => a - b,
    customFilter: true,
  },
  {
    title: "",
    dataIndex: DocumentManagerColumKeys.ACTIONS,
    key: DocumentManagerColumKeys.ACTIONS,
    width: 30,
    ellipsis: true,
  },
];
export enum EntityType {
  CASE = "c",
  SUBCASE = "s",
  AR = "a",
  CREDITOR = "cre",
}

export enum DocumentType {
  ENTITY_DOCUMENT = "EntityDocument",
}
export type DocumentItem = {
  documentId: number;
  documentName: string;
  assignTo?: string;
  documentCategory?: string;
  mappedBy?: string;
  mappedDate?: string;
  entityType?: string;
  key: string;
};
